import React from 'react';
import createClass from 'create-react-class';
import PropTypes from 'prop-types';
import {clone, pick, has} from 'lodash';
import moment from 'moment';
import i18n from 'i18n';
import {Radio} from 'ui-library';

import API from '../lib/api';
import dateDiff from 'utils/dateDiff';

import UploadAvatarContainer from './upload-avatar-container';
import DateSelect from './date-select';
import DebounceInput from 'apps/shared/components/DebounceInput';

import deepLinkState from '../mixins/deepLinkState';
import {linkMixin} from '../lib/mixins';

const SettingsAccountContent = createClass({
  propTypes: {
    user: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    onSave: PropTypes.func
  },

  mixins: [deepLinkState, linkMixin],

  getInitialState() {
    const initialUserData = clone(this.props.user);
    const {
      _id: id,
      name,
      lastName,
      gender,
      profileImage,
      birthday
    } = initialUserData;

    return {
      userData: {
        id, name, lastName, gender, profileImage, birthday
      },
      avatarUrl: '',
      showErrors: false
    };
  },

  validateData(userData) {
    const {user} = this.props;
    const requireInfluencerInputs = user.role === 'influencer';
    let isValid = true;
    isValid = isValid && this.validateName(userData);
    if (requireInfluencerInputs) {
      isValid = isValid && this.validateGender(userData);
      isValid = isValid && this.validateBirthday(userData);
    }
    return isValid;
  },

  validateName(userData) {
    const {name = ''} = userData;
    return name.trim().length > 0;
  },

  validateGender(userData) {
    const {gender} = userData;
    return !!gender;
  },

  validateBirthday(userData) {
    const {birthday} = userData;

    if (!birthday) return false;

    return this.isValidAge(userData);
  },

  isValidAge(userData) {
    const {birthday} = userData;
    return Math.floor(dateDiff(moment(), birthday).years) >= 13;
  },

  onNameChange(event) {
    const name = event.target.value;
    const {userData} = this.state;
    const newUserData = Object.assign({}, userData, {name});
    this.setState({
      userData: newUserData
    });
  },

  onLastNameChange(event) {
    const lastName = event.target.value;
    const {userData} = this.state;
    const newUserData = Object.assign({}, userData, {lastName});
    this.setState({
      userData: newUserData
    });
  },

  onDateChange(birthday) {
    const {userData} = this.state;
    const newUserData = Object.assign({}, userData, {birthday});
    this.setState({
      userData: newUserData
    });
  },

  onGenderChange(event) {
    var state = this.state;
    state.userData.gender = event.target.getAttribute('data-value');
    this.setState(state);
  },

  onSelectImage(id, image) {
    const {userData} = this.state;
    const updateData = {id: userData.id, profileImage: image};
    const newUserData = Object.assign({}, userData, updateData);
    this.setState({
      userData: newUserData
    });

    API.auto('updateUser', updateData, {});
  },

  saveData() {
    const {userData} = this.state;
    const isValid = this.validateData(userData);
    const storeData = pick(userData, ['id', 'name', 'lastName', 'gender', 'profileImage', 'birthday']);

    if (!isValid) return this.setState({showErrors: true});

    API.auto('updateUser', storeData, {
      successMessage: i18n.get('ADV_SETTINGS_ACCOUNT_CONTENT_SAVE_SUCCESS_MESSAGE'),
      callback: (err) => {
        if (err) return console.error(err);
        if (has(this.props, 'onSave')) this.props.onSave();
      }
    });
  },

  getInfluencerInputs() {
    const {disabled} = this.props;
    const {userData, showErrors} = this.state;
    const {gender, birthday} = userData;
    const errorOnGender = showErrors && !this.validateGender(userData);
    const errorOnBirthday = showErrors && !this.validateBirthday(userData);


    return (
      <div>
        <div className='vf-simple-form-label margin-top-1x'>
          {i18n.get('ADV_SETTINGS_ACCOUNT_CONTENT_BIRTH_DATE')}
        </div>

        <DateSelect
          className={errorOnBirthday ? 'error' : ''}
          initialDate={birthday}
          onChange={this.onDateChange}
          value={birthday}
          disabled={disabled}
        />

        {errorOnBirthday &&
          <div className='vf-text-danger margin-top-Hx'>
            {i18n.get('REQUIRED')}
          </div>
        }

        <div className='vf-simple-form-label'>
          {i18n.get('ADV_SETTINGS_ACCOUNT_CONTENT_GENDER_LABEL')}
        </div>

        <Radio
          name='gender'
          checked={gender === 'male'}
          className='margin-top-Hx'
          data-value='male'
          disabled={disabled}
          id='male-gender'
          onChange={this.onGenderChange}
        >
          {i18n.get('ADV_SETTINGS_ACCOUNT_CONTENT_GENDER_MALE')}
        </Radio>

        <Radio
          checked={gender === 'female'}
          className='margin-top-Hx'
          data-value='female'
          disabled={disabled}
          id='female-gender'
          name='gender'
          onChange={this.onGenderChange}
        >
          {i18n.get('ADV_SETTINGS_ACCOUNT_CONTENT_GENDER_FEMALE')}
        </Radio>

        {errorOnGender &&
          <div className='vf-text-danger margin-top-Hx'>
            {i18n.get('REQUIRED')}
          </div>
        }
      </div>
    );
  },

  render() {
    const {user, disabled} = this.props;
    const {userData, showErrors} = this.state;
    const {name, lastName} = userData;
    const userProfileImage = userData.profileImage;
    const influencerInputs = user.role === 'influencer' ? this.getInfluencerInputs() : null;
    const errorOnName = showErrors && !this.validateName(userData);

    return (
      <div className='vf-row'>
        <div className='col-xs-12 col-md-4 vf-settings-avatar' id='avatar-container'>
          <UploadAvatarContainer image={userProfileImage} onChange={this.onSelectImage} />
        </div>

        <div className='col-xs-12 col-md-8'>
          <div className='vf-simple-form-label'>
            {i18n.get('ADV_SETTINGS_ACCOUNT_CONTENT_FIRST_NAME')}
          </div>

          <DebounceInput
            id='name-input'
            disabled={disabled}
            hasError={errorOnName}
            onChange={this.onNameChange}
            value={name}
          />

          {errorOnName && (
            <div className='vf-text-danger margin-top-Hx'>
              {i18n.get('REQUIRED')}
            </div>
          )}

          <div className='vf-simple-form-label'>
            {i18n.get('ADV_SETTINGS_ACCOUNT_CONTENT_LAST_NAME')}
            <br />
            <span className='details'>
              {i18n.get('ADV_SETTINGS_ACCOUNT_CONTENT_OPTIONAL')}
            </span>
          </div>
          <DebounceInput
            id='last-name-input'
            disabled={disabled}
            onChange={this.onLastNameChange}
            value={lastName}
          />
          {influencerInputs}
        </div>
      </div>
    );
  }
});

module.exports = SettingsAccountContent;
